<template>
    <span>
        <label v-for="item in list" :key="item.value">
            <input type="checkbox"  :value="item.value" @change="updateValue($event.target.checked, $event.target.value)" :checked="isIncluded(item.value)" /> {{item.display}}
        </label>
    </span>
</template>

<script>
    export default {
        name: 'SemicolonListControl',
        props: ["list", "value"],
        methods: {
            updateValue(isIncluded, value) {
                var newValue = this.value;
                if (isIncluded) {
                    if (!this.isIncluded(value))
                        if (newValue === "" || newValue === null)
                            newValue = value;
                        else
                            newValue = newValue + ";" + value;
                }
                else {
                    
                    newValue = (";" + newValue + ";").replace(";" + value + ";", ";");
                    if (newValue.length > 0)
                        newValue = newValue.substr(1, newValue.length - 2)
                }
                this.$emit('input', newValue);
            },
            isIncluded(value) {
                if (value === null)
                    return false;
                return (";" + this.value + ";").indexOf(";" + value + ";") >= 0
            }
        }
    }
</script>